import Image from "./Image.js";
import ContactButton from "./ContactButton.js";
import Gallery from "./Gallery.js";

export default function Site() {
  return (
    <div className="project-page">
      <Image />
      <ContactButton />
      <Gallery />
    </div>
  );
}
